import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SavedModalService {
  discard: EventEmitter<boolean> = new EventEmitter();
  save: EventEmitter<string> = new EventEmitter();
  error: EventEmitter<string> = new EventEmitter();
  constructor() { }

  public onExit(showModal: boolean) {
    this.discard.emit(showModal);
  }

  public onSave(message: string = 'Saved Successfully') {
    this.save.emit(message);
  }

  public onError(message: string = 'An error occured') {
    this.error.emit(message);
  }
}
